var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 261,
    viewBox: "0 0 312 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    filter: "url(#filter0_d_201_392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M155.369 165.099C141.338 164.941 128.391 159.62 116.395 151.626C100.12 140.788 86.9548 126.757 75.5389 110.967C74.916 110.109 74.5662 109.44 75.3554 108.354C88.7422 89.9123 104.211 73.7276 124.372 62.6832C135.771 56.4401 147.908 53.0418 161.022 54.196C172.826 55.2344 183.487 59.6196 193.414 65.8884C210.9 76.9285 224.854 91.6587 236.812 108.418C237.17 108.92 237.209 110.109 236.863 110.59C223.105 129.658 207.133 146.327 186.055 157.325C176.652 162.229 166.674 165.078 155.373 165.099H155.369ZM157.144 154.016C181.819 153.205 201.118 132.773 200.35 108.277C199.578 83.7036 179.063 64.1978 154.87 65.0388C130.349 65.8927 111.113 86.3682 111.894 110.783C112.679 135.304 133.092 154.806 157.144 154.016Z",
    fill: "#4059C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M138.027 104.364C140.408 108.852 143.906 111.375 149.089 110.482C153.274 109.766 156.038 107.174 156.943 103.016C158.129 97.5842 155.646 93.8083 150.868 91.2854C158.12 88.4062 167.723 92.0534 172.262 99.2919C177.194 107.157 175.807 117.425 168.969 123.728C162.25 129.919 151.93 130.366 144.631 124.895C137.319 119.411 135.621 109.401 138.023 104.364H138.027Z",
    fill: "#4059C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_201_392",
    x: 0.898438,
    y: 0.972961,
    width: 310.204,
    height: 259.126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.252656 0 0 0 0 0.347548 0 0 0 0 0.7875 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_392",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.cefd093ab6a7b7678c135fad0356403f.svg";
export { ForwardRef as ReactComponent };